import { Box, styled } from '@mui/joy'
import { theme } from '@ui/style'

export interface BgWrapperProps {
	src?: {
		bgMoImgUrl: string
		bgTbImgUrl: string
		bgPcImgUrl: string
	}
}
const BgWrapper = styled(Box)(({ src }: BgWrapperProps) => ({
	position: 'absolute',
	top: 0,
	left: 0,
	width: '100%',
	height: '100%',
	backgroundSize: 'cover',
	backgroundPosition: 'center',
	backgroundRepeat: 'no-repeat',
	backgroundImage: `url(${src?.bgMoImgUrl})`,
	[theme.breakpoints.up('md')]: {
		backgroundImage: `url(${src?.bgTbImgUrl})`,
	},
	[theme.breakpoints.up('lg')]: {
		backgroundImage: `url(${src?.bgPcImgUrl})`,
	},
	'&::before': {
		content: '""',
		display: 'block',
		width: '100%',
		height: '100%',
		position: 'absolute',
		top: 0,
		left: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.3)',
	},
	'&::after': {
		content: '""',
		display: 'block',
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		height: '60%',
		backdropFilter: 'blur(20px)',
		background: 'linear-gradient(to top, rgba(217, 217, 217, 0.3) 50%, transparent 100%)',
		maskImage: 'linear-gradient(to top, #000 30%, transparent 100%)',
	},
}))

export default BgWrapper
